import { render, staticRenderFns } from "./LowMovingStock.vue?vue&type=template&id=67aa1fff&scoped=true&"
import script from "./LowMovingStock.vue?vue&type=script&lang=js&"
export * from "./LowMovingStock.vue?vue&type=script&lang=js&"
import style0 from "./LowMovingStock.vue?vue&type=style&index=0&id=67aa1fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa1fff",
  null
  
)

export default component.exports